/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import produce from 'immer';
import {UserPromptTypes} from '@ion/applications/src/prompts/constants';
import {GenericObject} from '@ion/core/src/types/entities';
import {TOGGLE_USER_PROMPT} from '@/store/actions/user-prompt';

// defines the shape of this reducers state ...
export interface UserPromptState {
  notification: {
    display: boolean;
    text: string;
    translateText: boolean;
    translateOption?: GenericObject;
    type: UserPromptTypes;
    actionLabel: string;
    autoHide: boolean;
    customDismissLabel: string;
    onDismiss?: () => void;
    onAction: () => void,
    autoHideDuration: number;
    partialSuccessState?: string | null;
  };
}

// defines the initial state for the reducer ...
export const initialState: UserPromptState = {
  notification : {
    display             : false,
    text                : '',
    translateText       : true,
    translateOption     : {},
    type                : UserPromptTypes.Error,
    actionLabel         : '',
    autoHide            : true,
    customDismissLabel  : '',
    onDismiss           : null,
    onAction            : null,
    autoHideDuration    : 4000,
    partialSuccessState : null
  }
};

// defines the reducers ...
const reducers = {
  [TOGGLE_USER_PROMPT] : ({notification}: UserPromptState, {options}) => {
    const {
      display, message, translateText, translateOption, type, actionLabel, autoHide,
      customDismissLabel, onDismiss, onAction, autoHideDuration, partialSuccessState
    } = options || {};
    notification.display             = display ?? !notification.display;
    notification.text                = message || '';
    notification.translateText       = translateText !== false;
    notification.translateOption     = translateOption || {};
    notification.type                = type || null;
    notification.actionLabel         = actionLabel;
    notification.autoHide            = autoHide !== false;
    notification.customDismissLabel  = customDismissLabel || '';
    notification.onDismiss           = onDismiss || null;
    notification.onAction            = onAction || null;
    notification.autoHideDuration    = autoHideDuration ?? 4000;
    notification.partialSuccessState = partialSuccessState || null;
  }
};

// defines all reducers for actions of interest to the this reducer ...
export default produce((draft: UserPromptState = initialState, action) => {
  reducers?.[action.type]?.(draft, action);
  return draft;
});
